<template>
<div class="cards">
  <div
    class="grid"
    ref="grid"
    v-on:scroll="onScroll"
  >
    <HomeCardItem
      v-for="card, i in cards" :key="i"
      :imgName="card.imgName"
      :route="card.route"
      :isNew="card.isNew"
    >
      <template v-slot:title>{{card.title}}</template>
      <template v-slot:description>
        <span v-html="card.description"></span>
      </template>
      <template v-slot:extra v-if="card.extra">{{card.extra}}</template>
    </HomeCardItem>
  </div>


  <div class="scrollbar" v-if="isScrollView" ref="scrollbar">
    <div
      class="thumb"
      ref="thumb"
      :style="thumbStyle"
      v-on:mousedown="onMouseDown"
      v-on:touchstart.passive="onTouchStart"
    >
    </div>
  </div>
</div>
</template>

<script>
import HomeCardItem from './HomeCardItem'

export default {
  props: {
    cards: Array,
    title: String,
    copy: String
  },
  data() {
    return {
      isScrollView: false,
      isScrollbarInit: false,
      isMouseDown: false,
      thumbX: 0
    }
  },
  created() {
    this.onResize()
  },
  mounted() {
    window.addEventListener('resize', this.onResize, false)
    if (this.isScrollView && !this.isScrollbarInit) {
      this.initScrollbar()
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize, false)
    document.removeEventListener('touchmove', this.onDragTouch, false, {passive: false, bubble: false})
    document.removeEventListener('touchend', this.onDragTouchEnd, false)
    document.removeEventListener('mousemove', this.onDrag, false)
    document.removeEventListener('mouseup', this.onDragEnd, false)
  },
  methods: {
    onResize() {
      if (!this.isScrollView && window.innerWidth <= 768) {
        this.isScrollView = true
        if (!this.isScrollbarInit) {
          this.initScrollbar()
        }
      } else if (this.isScrollView && window.innerWidth > 768) {
        this.isScrollView = false
      }
    },
    initScrollbar() {
      this.isScrollbarInit = true
    },
    onScroll() {
      if (this.isMouseDown) return
      const scrollbar = this.$refs.scrollbar
      const scrollRect = scrollbar.getBoundingClientRect()
      const thumb = this.$refs.thumb
      const thumbRect = thumb.getBoundingClientRect()
      const grid = this.$refs.grid
      const perc = grid.scrollLeft/(grid.scrollWidth - grid.clientWidth)
      this.thumbX = (scrollRect.width - thumbRect.width)  * perc
    },
    onTouchStart() {
      this.isMouseDown = true
      document.body.classList.add('is-grabbing')
      document.addEventListener('touchmove', this.onDragTouch, false, {passive: false, bubble: false})
      document.addEventListener('touchend', this.onDragTouchEnd, false)
    },
    onDragTouch(e) {
      const scrollbar = this.$refs.scrollbar
      const scrollRect = scrollbar.getBoundingClientRect()
      const thumb = this.$refs.thumb
      const thumbRect = thumb.getBoundingClientRect()
      const grid = this.$refs.grid

      const currentScroll = Math.max(e.touches[0].clientX - scrollRect.left, 0)
      const maxScrollPx = scrollRect.width - thumbRect.width

      this.thumbX = Math.min(
        currentScroll,
        maxScrollPx
      )

      const scrollPercentage = this.thumbX / maxScrollPx
      grid.scrollLeft = scrollPercentage * (grid.scrollWidth - grid.clientWidth)
    },
    onDragTouchEnd() {
      this.isMouseDown = false
      document.body.classList.remove('is-grabbing')
      document.removeEventListener('mousemove', this.onDrag, false)
      document.removeEventListener('mouseup', this.onDragEnd, false)
    },
    onMouseDown() {
      this.isMouseDown = true
      document.body.classList.add('is-grabbing')
      document.addEventListener('mousemove', this.onDrag, false)
      document.addEventListener('mouseup', this.onDragEnd, false)
    },
    onDrag(e) {
      e.preventDefault()
      const scrollbar = this.$refs.scrollbar
      const scrollRect = scrollbar.getBoundingClientRect()
      const thumb = this.$refs.thumb
      const thumbRect = thumb.getBoundingClientRect()
      const grid = this.$refs.grid

      const currentScroll = Math.max(e.clientX - scrollRect.left, 0)
      const maxScrollPx = scrollRect.width - thumbRect.width

      this.thumbX = Math.min(
        currentScroll,
        maxScrollPx
      )

      const scrollPercentage = this.thumbX / maxScrollPx
      grid.scrollLeft = scrollPercentage * (grid.scrollWidth - grid.clientWidth)
    },
    onDragEnd() {
      this.isMouseDown = false
      document.body.classList.remove('is-grabbing')
      document.removeEventListener('mousemove', this.onDrag, false)
      document.removeEventListener('mouseup', this.onDragEnd, false)
    },
  },
  computed: {
    thumbStyle() {
      // transform: translate3d(${this.thumbX}px, 0, 0);
      return `
        transform: translate3d(${this.thumbX}px, 0, 0)
      `
    }
  },
  components: {
    HomeCardItem
  }
}
</script>

<style lang="scss" scoped>

.cards {
  max-width: 1200px;
  margin: 0 auto;
  @media screen and (max-width: 1104px) {
    max-width: 784px;
  }
  @media screen and (max-width: 768px) {
    width: auto;
    // white-space: nowrap;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    // overflow: visible;
    // overflow-x: scroll;
    // overflow-y: visible;
    margin-top: 0 !important;
    margin-bottom: 60px !important;
    // -webkit-overflow-scrolling: touch;
  }
}

.grid {
  grid-gap: 24px 40px;
  margin: 0 20px;

  @media screen and (max-width: 1104px) {
    grid-gap: 16px 24px;
  }
  @media screen and (max-width: 768px) {
    width: auto;
    white-space: nowrap;
    display: flex;
    flex-wrap: nowrap;
    max-width: none;
    white-space: nowrap;
    margin: 0 0;
    padding: 30px 20px;
    // padding-left: 20px;
    overflow-x: scroll;
    overflow-y: visible;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.scrollbar {
  position: relative;
  height: 10px;
  width: 166px;
  background-color: var(--gray-300);
  border-radius: 10px;
  margin: 30px auto 0;
  .thumb {
    position: absolute;
    cursor: grab;
    top: 0;
    left: 0;
    width: 37px;
    // width: 1px;
    // transform: translateX(100%);
    height: 10px;
    border-radius: 10px;
    background-color: var(--gray-500);
  }
}

</style>